"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Expand2: ['expand-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.5,5.267a.25.25,0,0,1,.354,0l1.439,1.439A1,1,0,0,0,23,7a.987.987,0,0,0,.383-.076A1,1,0,0,0,24,6V1a1,1,0,0,0-1-1H18a1,1,0,0,0-.707,1.707l1.439,1.439a.25.25,0,0,1,0,.354l-6.555,6.556a.252.252,0,0,1-.354,0L5.268,3.5a.25.25,0,0,1,0-.354L6.707,1.706A1,1,0,0,0,6,0H1A1,1,0,0,0,0,1V6a1,1,0,0,0,.617.924A.987.987,0,0,0,1,7a1,1,0,0,0,.707-.293L3.146,5.267a.25.25,0,0,1,.354,0l6.556,6.555a.252.252,0,0,1,0,.354L3.5,18.731a.25.25,0,0,1-.354,0L1.707,17.292A1,1,0,0,0,0,18v5a1,1,0,0,0,1,1H6a1,1,0,0,0,.707-1.707l-1.439-1.44a.249.249,0,0,1,0-.353l6.555-6.556a.252.252,0,0,1,.354,0L18.732,20.5a.249.249,0,0,1,0,.353l-1.439,1.44A1,1,0,0,0,18,24h5a1,1,0,0,0,1-1V18a1,1,0,0,0-1.707-.707l-1.439,1.439a.25.25,0,0,1-.354,0l-6.556-6.555a.252.252,0,0,1,0-.354Z']],
  Expand6Alternate: ['expand-6-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.25,7.242a1,1,0,0,0-1-1H6.75a3,3,0,0,0-3,3v8a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3v-2.5a1,1,0,0,0-2,0v2.5a1,1,0,0,1-1,1h-8a1,1,0,0,1-1-1v-8a1,1,0,0,1,1-1h3.5A1,1,0,0,0,11.25,7.242Z', 'M9.75,15.742a1.5,1.5,0,0,0,1.06-.438l6.468-6.458a.249.249,0,0,1,.353,0L19.4,10.611a.5.5,0,0,0,.354.147.512.512,0,0,0,.191-.038.5.5,0,0,0,.309-.462v-6a.5.5,0,0,0-.5-.5h-6a.5.5,0,0,0-.354.853l1.761,1.76a.255.255,0,0,1,.073.177.25.25,0,0,1-.074.177L8.69,13.181a1.5,1.5,0,0,0,1.06,2.561Z']],
  Expand: ['expand', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.75,5.8a2.207,2.207,0,0,0-2.2-2.2H16.3a1.25,1.25,0,0,0,0,2.5H21a.25.25,0,0,1,.25.25V9.612a1.25,1.25,0,1,0,2.5,0Z', 'M.25,9.612a1.25,1.25,0,0,0,2.5,0V6.34A.25.25,0,0,1,3,6.09H7.705a1.25,1.25,0,0,0,0-2.5H2.455A2.207,2.207,0,0,0,.25,5.8Z', 'M23.75,18.2V14.386a1.25,1.25,0,1,0-2.5,0v3.272a.25.25,0,0,1-.25.25H16.3a1.25,1.25,0,0,0,0,2.5h5.25A2.207,2.207,0,0,0,23.75,18.2Z', 'M.25,18.2a2.207,2.207,0,0,0,2.205,2.205h5.25a1.25,1.25,0,0,0,0-2.5H3a.25.25,0,0,1-.25-.25V14.386a1.25,1.25,0,0,0-2.5,0Z', 'M4.795 8.612 L19.204 8.612 L19.204 15.385 L4.795 15.385 Z']],
  Expand3: ['expand-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,23a1,1,0,0,0,1,1H6a1,1,0,0,0,.707-1.707l-1.439-1.44a.249.249,0,0,1,0-.353l4.116-4.116a1.25,1.25,0,1,0-1.768-1.768L3.5,18.731a.25.25,0,0,1-.354,0L1.707,17.292A1,1,0,0,0,0,18Z', 'M24,1a1,1,0,0,0-1-1H18a1,1,0,0,0-.707,1.707l1.439,1.439a.25.25,0,0,1,0,.354L14.616,7.615a1.25,1.25,0,0,0,1.768,1.768L20.5,5.267a.25.25,0,0,1,.354,0l1.439,1.439A1,1,0,0,0,23,7a.987.987,0,0,0,.383-.076A1,1,0,0,0,24,6Z']],
  Expand7: ['expand-7', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.25,12a1.246,1.246,0,0,0,.884-.366L20.6,5.163a.25.25,0,0,1,.354,0L22.9,7.1a.5.5,0,0,0,.354.147.512.512,0,0,0,.191-.038.5.5,0,0,0,.309-.462v-6a.5.5,0,0,0-.5-.5h-6A.5.5,0,0,0,16.9,1.1l1.94,1.94a.249.249,0,0,1,0,.353l-6.47,6.47A1.25,1.25,0,0,0,13.25,12Z', 'M0.250 12.749 L11.250 12.749 L11.250 23.749 L0.250 23.749 Z']],
  Expand4: ['expand-4', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,1a1,1,0,0,0-1-1H16.5a1,1,0,0,0-.707,1.707L17.982,3.9a.25.25,0,0,1,0,.354L13.616,8.615a1.25,1.25,0,0,0,1.768,1.768L19.75,6.017a.25.25,0,0,1,.354,0l2.189,2.189A1,1,0,0,0,23,8.5a.987.987,0,0,0,.383-.076A1,1,0,0,0,24,7.5Z', 'M1,24H7.5a1,1,0,0,0,.707-1.707L6.018,20.1a.249.249,0,0,1,0-.353l4.366-4.366a1.25,1.25,0,1,0-1.768-1.768L4.25,17.981a.25.25,0,0,1-.354,0L1.707,15.792A1,1,0,0,0,0,16.5V23A1,1,0,0,0,1,24Z']],
  Expand6: ['expand-6', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M3.75,17.241a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V12.208a1,1,0,0,0-.294-.71h0a1,1,0,0,0-1.419,0l-4.52,4.514a2.5,2.5,0,0,1-3.668-.146,2.606,2.606,0,0,1,.244-3.5l4.407-4.4a1,1,0,0,0,0-1.42l-.007-.007a1,1,0,0,0-.71-.294H6.75a3,3,0,0,0-3,3Z', 'M16.924,8.491a.25.25,0,0,1,.353,0L19.4,10.61a.5.5,0,0,0,.354.147.512.512,0,0,0,.191-.038.5.5,0,0,0,.309-.462v-6a.5.5,0,0,0-.5-.5h-6a.5.5,0,0,0-.354.853l2.113,2.113a.249.249,0,0,1,0,.354L9.043,13.533a1,1,0,0,0,1.414,1.416Z']],
  Shrink3: ['shrink-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.384.615a1.251,1.251,0,0,0-1.768,0L16.773,5.459a.252.252,0,0,1-.354,0l-2.28-2.28a1,1,0,0,0-1.707.707v6.681a1,1,0,0,0,1,1h6.682a1,1,0,0,0,.707-1.707L18.54,7.58a.251.251,0,0,1,0-.354l4.844-4.843A1.251,1.251,0,0,0,23.384.615Z', 'M.616,23.383a1.251,1.251,0,0,0,1.768,0l4.843-4.844a.25.25,0,0,1,.354,0l2.28,2.28a1,1,0,0,0,.707.293.987.987,0,0,0,.383-.076,1,1,0,0,0,.617-.924V13.431a1,1,0,0,0-1-1H3.886a1,1,0,0,0-.707,1.707l2.281,2.28a.251.251,0,0,1,0,.354L.616,21.615A1.251,1.251,0,0,0,.616,23.383Z']],
  Shrink4: ['shrink-4', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.015 9.015 L15.015 9.015 L15.015 15.015 L9.015 15.015 Z', 'M21.977,16.323a.5.5,0,0,0-.462-.308h-5a.5.5,0,0,0-.5.5v5a.5.5,0,0,0,.854.353l1.439-1.44a.252.252,0,0,1,.354,0l2.2,2.2a1.25,1.25,0,0,0,1.768-1.768l-2.205-2.2a.252.252,0,0,1,0-.354l1.44-1.439A.5.5,0,0,0,21.977,16.323Z', 'M8.015,2.515a.5.5,0,0,0-.853-.354L5.722,3.6a.249.249,0,0,1-.353,0L3.134,1.365A1.25,1.25,0,0,0,1.366,3.133L3.6,5.368a.249.249,0,0,1,0,.353L2.162,7.161a.5.5,0,0,0,.353.854h5a.5.5,0,0,0,.5-.5Z', 'M22.634,1.365a1.251,1.251,0,0,0-1.768,0l-2.22,2.22a.249.249,0,0,1-.353,0L16.869,2.161a.5.5,0,0,0-.854.354v5a.5.5,0,0,0,.5.5h5a.5.5,0,0,0,.354-.854L20.414,5.706a.249.249,0,0,1,0-.353l2.22-2.22A1.251,1.251,0,0,0,22.634,1.365Z', 'M1.366,22.633a1.251,1.251,0,0,0,1.768,0l2.219-2.22a.252.252,0,0,1,.354,0l1.455,1.455a.5.5,0,0,0,.853-.353v-5a.5.5,0,0,0-.5-.5h-5a.5.5,0,0,0-.353.853l1.424,1.424a.252.252,0,0,1,0,.354l-2.22,2.219A1.251,1.251,0,0,0,1.366,22.633Z']],
  Expand8: ['expand-8', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1.967,13.41H9.134a1.455,1.455,0,0,1,1.455,1.455v7.167a1.456,1.456,0,0,1-1.456,1.456H1.967A1.456,1.456,0,0,1,.511,22.032V14.865A1.456,1.456,0,0,1,1.967,13.41Z', 'M1.489,9.426a1.25,1.25,0,0,0,1.25-1.25V2.988a.25.25,0,0,1,.25-.25H8.178a1.25,1.25,0,0,0,0-2.5H2.444a2.207,2.207,0,0,0-2.2,2.205V8.176A1.249,1.249,0,0,0,1.489,9.426Z', 'M23.761,2.443a2.207,2.207,0,0,0-2.2-2.2H15.822a1.25,1.25,0,0,0,0,2.5h5.189a.25.25,0,0,1,.25.25V8.176a1.25,1.25,0,0,0,2.5,0Z', 'M23.761,21.554V15.821a1.25,1.25,0,0,0-2.5,0V21.01a.25.25,0,0,1-.25.25H16.3a1.25,1.25,0,0,0,0,2.5h5.256A2.208,2.208,0,0,0,23.761,21.554Z']],
  Shrink1: ['shrink-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.384.615a1.251,1.251,0,0,0-1.768,0L18.2,4.027a.251.251,0,0,1-.354,0L16.525,2.7a1,1,0,0,0-1.707.707V8.181a1,1,0,0,0,1,1h4.773A1,1,0,0,0,21.3,7.474L19.972,6.148a.25.25,0,0,1,0-.353l3.412-3.412A1.251,1.251,0,0,0,23.384.615Z', 'M.616,23.383a1.251,1.251,0,0,0,1.768,0L5.8,19.971a.251.251,0,0,1,.354,0L7.475,21.3a1,1,0,0,0,1.707-.707V15.817a1,1,0,0,0-1-1H3.409A1,1,0,0,0,2.7,16.524L4.028,17.85a.25.25,0,0,1,0,.353L.616,21.615A1.251,1.251,0,0,0,.616,23.383Z', 'M14.818,20.59a1,1,0,0,0,1.707.707l1.326-1.326a.251.251,0,0,1,.354,0l3.411,3.412a1.25,1.25,0,0,0,1.768-1.768L19.972,18.2a.25.25,0,0,1,0-.353L21.3,16.524a1,1,0,0,0-.707-1.707H15.818a1,1,0,0,0-1,1Z', 'M9.182,3.408a1,1,0,0,0-.618-.924A.99.99,0,0,0,7.475,2.7L6.149,4.027a.251.251,0,0,1-.354,0L2.384.615A1.25,1.25,0,0,0,.616,2.383L4.028,5.8a.25.25,0,0,1,0,.353L2.7,7.474a1,1,0,0,0,.707,1.707H8.182a1,1,0,0,0,1-1Z']],
  Shrink2: ['shrink-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M.616,23.383a1.251,1.251,0,0,0,1.768,0L6.5,19.267a.25.25,0,0,1,.354,0l1.439,1.439A1,1,0,0,0,9,21a.987.987,0,0,0,.383-.076A1,1,0,0,0,10,20V15a1,1,0,0,0-1-1H4a1,1,0,0,0-.707,1.707l1.439,1.439a.25.25,0,0,1,0,.354L.616,21.615A1.251,1.251,0,0,0,.616,23.383Z', 'M23.384.615a1.251,1.251,0,0,0-1.768,0L17.5,4.731a.25.25,0,0,1-.354,0L15.707,3.292A1,1,0,0,0,14,4V9a1,1,0,0,0,1,1h5a1,1,0,0,0,.707-1.707l-1.439-1.44a.249.249,0,0,1,0-.353l4.116-4.116A1.251,1.251,0,0,0,23.384.615Z']],
  ExpandFull: ['expand-full', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.75,2.453a2.206,2.206,0,0,0-2.2-2.2H15.818a1.25,1.25,0,0,0,0,2.5H21a.25.25,0,0,1,.25.25V6.271a1.25,1.25,0,1,0,2.5,0Z', 'M.25,6.271a1.25,1.25,0,0,0,2.5,0V3A.25.25,0,0,1,3,2.749H8.182a1.25,1.25,0,0,0,0-2.5H2.455a2.206,2.206,0,0,0-2.2,2.2Z', 'M23.75,21.545V17.726a1.25,1.25,0,0,0-2.5,0V21a.25.25,0,0,1-.25.25H15.818a1.25,1.25,0,0,0,0,2.5h5.727A2.206,2.206,0,0,0,23.75,21.545Z', 'M.25,21.545a2.206,2.206,0,0,0,2.205,2.2H8.182a1.25,1.25,0,0,0,0-2.5H3A.25.25,0,0,1,2.75,21V17.726a1.25,1.25,0,0,0-2.5,0Z', 'M5.273 8.136 L18.727 8.136 L18.727 15.863 L5.273 15.863 Z']],
  Expand1: ['expand-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,23a1,1,0,0,0,1,1H6a1,1,0,0,0,.707-1.707l-1.439-1.44a.249.249,0,0,1,0-.353l3.616-3.616a1.25,1.25,0,1,0-1.768-1.768L3.5,18.731a.25.25,0,0,1-.354,0L1.707,17.292A1,1,0,0,0,0,18Z', 'M24,1a1,1,0,0,0-1-1H18a1,1,0,0,0-.707,1.707l1.439,1.439a.25.25,0,0,1,0,.354L15.116,7.115a1.25,1.25,0,0,0,1.768,1.768L20.5,5.267a.25.25,0,0,1,.354,0l1.439,1.439A1,1,0,0,0,23,7a.987.987,0,0,0,.383-.076A1,1,0,0,0,24,6Z', 'M0,6a1,1,0,0,0,.617.924A.987.987,0,0,0,1,7a1,1,0,0,0,.707-.293L3.323,5.09,7.116,8.883A1.25,1.25,0,1,0,8.884,7.115L5.268,3.5a.25.25,0,0,1,0-.354L6.707,1.706A1,1,0,0,0,6,0H1A1,1,0,0,0,0,1Z', 'M24,18a1,1,0,0,0-1.707-.707l-1.439,1.439a.25.25,0,0,1-.354,0l-3.616-3.616a1.25,1.25,0,1,0-1.768,1.768L18.732,20.5a.249.249,0,0,1,0,.353l-1.439,1.44A1,1,0,0,0,18,24h5a1,1,0,0,0,1-1Z']],
  Shrink: ['shrink', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.384.615a1.251,1.251,0,0,0-1.768,0L17.851,4.38a.25.25,0,0,1-.354,0L16.172,3.055a.5.5,0,0,0-.854.353V8.181a.5.5,0,0,0,.5.5h4.773a.5.5,0,0,0,.353-.854L19.618,6.5a.253.253,0,0,1-.073-.177.249.249,0,0,1,.074-.176l3.765-3.765A1.251,1.251,0,0,0,23.384.615Z', 'M.616,23.383a1.251,1.251,0,0,0,1.768,0l3.765-3.765a.249.249,0,0,1,.353,0l1.326,1.325a.5.5,0,0,0,.354.147.512.512,0,0,0,.191-.038.5.5,0,0,0,.309-.462V15.817a.5.5,0,0,0-.5-.5H3.409a.5.5,0,0,0-.353.854L4.381,17.5a.25.25,0,0,1,0,.354L.616,21.615A1.251,1.251,0,0,0,.616,23.383Z', 'M15.627,21.052a.512.512,0,0,0,.191.038.5.5,0,0,0,.354-.147L17.5,19.618a.249.249,0,0,1,.353,0l3.765,3.765a1.25,1.25,0,0,0,1.768-1.768L19.619,17.85a.25.25,0,0,1,0-.354l1.325-1.325a.5.5,0,0,0-.353-.854H15.818a.5.5,0,0,0-.5.5V20.59A.5.5,0,0,0,15.627,21.052Z', 'M8.682,3.408a.5.5,0,0,0-.854-.353L6.5,4.38a.247.247,0,0,1-.353,0L2.384.615A1.25,1.25,0,0,0,.616,2.383L4.381,6.148a.25.25,0,0,1,0,.354L3.056,7.827a.5.5,0,0,0,.353.854H8.182a.5.5,0,0,0,.5-.5Z', 'M9.091 11.999 A2.909 2.909 0 1 0 14.909 11.999 A2.909 2.909 0 1 0 9.091 11.999 Z']],
  TouchUp1: ['touch-up-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.266,23.745A9.1,9.1,0,0,0,21,14.871,9,9,0,0,0,15.866,6.63a.973.973,0,0,0-1.366.9v.049a1.01,1.01,0,0,0,.586.9A7,7,0,0,1,19,14.813a7.1,7.1,0,0,1-6.893,6.935A6.994,6.994,0,0,1,8.949,8.458a.942.942,0,0,0,.551-.84V7.534a.987.987,0,0,0-1.437-.87,9,9,0,0,0,4.2,17.081Z', 'M10.75,10.249a1.25,1.25,0,1,0,2.5,0V4.5a.25.25,0,0,1,.25-.25H15a.5.5,0,0,0,.354-.854L14.5,2.542,12.354.4a.5.5,0,0,0-.708,0L9.5,2.542,8.646,3.4A.5.5,0,0,0,9,4.249h1.5a.25.25,0,0,1,.25.25Z']],
  Expand5: ['expand-5', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7.000 6.999 L17.000 6.999 L17.000 16.999 L7.000 16.999 Z', 'M0,23.5a.5.5,0,0,0,.5.5h5a.5.5,0,0,0,.354-.854l-1.44-1.439a.25.25,0,0,1,0-.354l1.97-1.969a1.25,1.25,0,0,0-1.768-1.768l-1.969,1.97a.252.252,0,0,1-.354,0L.854,18.145A.5.5,0,0,0,0,18.5Z', 'M24,.5a.5.5,0,0,0-.5-.5h-5a.5.5,0,0,0-.354.853l1.44,1.44a.249.249,0,0,1,0,.353l-1.97,1.97a1.25,1.25,0,0,0,1.768,1.768l1.969-1.97a.25.25,0,0,1,.354,0l1.439,1.439A.5.5,0,0,0,23.5,6a.512.512,0,0,0,.191-.038A.5.5,0,0,0,24,5.5Z', 'M.5,0A.5.5,0,0,0,0,.5v5a.5.5,0,0,0,.309.462A.512.512,0,0,0,.5,6a.5.5,0,0,0,.354-.147L2.293,4.413a.25.25,0,0,1,.354,0l1.969,1.97A1.25,1.25,0,1,0,6.384,4.615l-1.97-1.97a.249.249,0,0,1,0-.353L5.854.852A.5.5,0,0,0,5.5,0Z', 'M24,23.5v-5a.5.5,0,0,0-.854-.354l-1.439,1.44a.252.252,0,0,1-.354,0l-1.969-1.97a1.25,1.25,0,0,0-1.768,1.768l1.97,1.969a.25.25,0,0,1,0,.354l-1.44,1.439A.5.5,0,0,0,18.5,24h5A.5.5,0,0,0,24,23.5Z']],
  TouchUp: ['touch-up', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.515,21.85a7.493,7.493,0,0,0,2.41-13.73A.927.927,0,0,0,14.5,8.9v.178a.957.957,0,0,0,.461.8,5.5,5.5,0,1,1-5.919,0A.95.95,0,0,0,9.5,9.078V8.9a.927.927,0,0,0-1.413-.786A7.5,7.5,0,0,0,13.515,21.85Z', 'M10.75,13a1.25,1.25,0,1,0,2.5,0V5.749a.25.25,0,0,1,.25-.25h1a.5.5,0,0,0,.354-.854l-.377-.376L12.354,2.145a.5.5,0,0,0-.708,0L9.523,4.269l-.377.376A.5.5,0,0,0,9.5,5.5h1a.25.25,0,0,1,.25.25Z']]
};
exports["default"] = _default;